import { JSX } from 'react'

import { IconProps } from '../../icon'

const LogOut: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M38.4395 24.7087C38.446 24.7022 38.446 24.7022 38.4526 24.6957C38.4722 24.6695 38.4917 24.6499 38.5048 24.6238C38.5113 24.6173 38.5113 24.6107 38.5179 24.6042C38.5309 24.5781 38.5505 24.552 38.5636 24.5258C38.5636 24.5193 38.5701 24.5128 38.5701 24.5128C38.5832 24.4866 38.5963 24.4605 38.6093 24.4278C38.6093 24.4213 38.6093 24.4213 38.6159 24.4148C38.6289 24.3887 38.6355 24.356 38.6485 24.3233C38.6485 24.3168 38.6485 24.3103 38.655 24.3103C38.6616 24.2776 38.6746 24.2515 38.6746 24.2188C38.6746 24.2058 38.6746 24.1992 38.6812 24.1862C38.6877 24.16 38.6877 24.1339 38.6942 24.1078C38.7008 24.0686 38.7008 24.0359 38.7008 23.9967C38.7008 23.9575 38.7008 23.9249 38.6942 23.8857C38.6942 23.8596 38.6877 23.8334 38.6812 23.8073C38.6812 23.7942 38.6812 23.7877 38.6746 23.7746C38.6681 23.742 38.6616 23.7159 38.655 23.6832C38.655 23.6767 38.655 23.6701 38.6485 23.6701C38.642 23.6375 38.6289 23.6114 38.6159 23.5787C38.6159 23.5722 38.6159 23.5722 38.6093 23.5656C38.5963 23.5395 38.5832 23.5068 38.5701 23.4807C38.5701 23.4742 38.5636 23.4676 38.5636 23.4676C38.5505 23.4415 38.5375 23.4154 38.5179 23.3893C38.5113 23.3827 38.5113 23.3762 38.5048 23.3697C38.4852 23.3435 38.4722 23.3174 38.4526 23.2978C38.446 23.2913 38.446 23.2913 38.4395 23.2848C38.4134 23.2586 38.3938 23.226 38.3611 23.1998L31.901 16.7463C31.4634 16.3086 30.7514 16.3086 30.3138 16.7463C29.8761 17.1839 29.8761 17.8959 30.3138 18.3335L34.86 22.8798H16.7861C16.1656 22.8798 15.6626 23.3827 15.6626 23.9967C15.6626 24.6173 16.1656 25.1202 16.7861 25.1202H34.8665L30.3529 29.6338C29.9153 30.0714 29.9153 30.7834 30.3529 31.2211C30.5685 31.4366 30.8559 31.5477 31.1433 31.5477C31.4307 31.5477 31.7181 31.4366 31.9337 31.2211L38.3546 24.8002C38.3872 24.761 38.4134 24.7348 38.4395 24.7087Z'
      fill='black'
    />
    <path
      d='M15.0812 10.2405H23.4421C24.0627 10.2405 24.5656 9.7375 24.5656 9.12349C24.5656 8.50296 24.0627 8 23.4421 8H15.0812C11.7304 8 9 10.7304 9 14.0812V33.9188C9 37.2696 11.7304 40 15.0812 40H23.305C23.9255 40 24.4285 39.497 24.4285 38.883C24.4285 38.2625 23.9255 37.7595 23.305 37.7595H15.0812C12.9649 37.7595 11.2405 36.0351 11.2405 33.9188V14.0812C11.247 11.9584 12.9649 10.2405 15.0812 10.2405Z'
      fill='black'
    />
  </svg>
)

export default LogOut
